import React, { useState } from 'react'

const SIZE_CONFIG = {
  xs:   { container: 'w-8 h-8',   text: 'text-xs',  iconSize: 'w-4 h-4' },
  sm:   { container: 'w-10 h-10', text: 'text-sm',  iconSize: 'w-5 h-5' },
  md:   { container: 'w-12 h-12', text: 'text-base', iconSize: 'w-6 h-6' },
  lg:   { container: 'w-16 h-16', text: 'text-xl',  iconSize: 'w-8 h-8' },
  xl:   { container: 'w-24 h-24', text: 'text-3xl', iconSize: 'w-12 h-12' },
  '2xl': { container: 'w-32 h-32', text: 'text-4xl', iconSize: 'w-16 h-16' },
}

function PersonIcon({ className }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
    </svg>
  )
}

export default function UserAvatar({
  src,
  name = '',
  size = 'md',
  fallback = 'initials',
  fallbackColor = '#3366FF',
  className = '',
  alt,
}) {
  const [imgError, setImgError] = useState(false)
  const config = SIZE_CONFIG[size] || SIZE_CONFIG.md
  const initial = (name || '').charAt(0).toUpperCase() || '?'
  const altText = alt ?? name ?? ''

  if (src && !imgError) {
    return (
      <img
        src={src}
        alt={altText}
        onError={() => setImgError(true)}
        className={`${config.container} rounded-full object-cover border border-gray-200 ${className}`}
      />
    )
  }

  if (fallback === 'icon') {
    return (
      <div className={`${config.container} rounded-full bg-gray-200 flex items-center justify-center ${className}`}>
        <PersonIcon className={`${config.iconSize} text-gray-400`} />
      </div>
    )
  }

  return (
    <div
      className={`${config.container} rounded-full flex items-center justify-center text-white font-bold ${config.text} ${className}`}
      style={{ backgroundColor: fallbackColor }}
    >
      {initial}
    </div>
  )
}
